(function () {
  const STORAGE_KEY = 'site-theme';

  function applyTheme(theme) {
    const isDark = theme === 'dark';
    const bg = isDark ? '#0d0e11' : '#ffffff';
    document.documentElement.setAttribute('data-theme', isDark ? 'dark' : 'light');
    // Mirror opencode's app: set color-scheme + inline html background +
    // theme-color meta together, so iOS Safari re-tints the status bar.
    document.documentElement.style.colorScheme = isDark ? 'dark' : 'light';
    document.documentElement.style.backgroundColor = bg;
    const meta = document.getElementById('theme-color-meta');
    // Accented tenants tint the toolbar with the day's hue; others use the surface.
    if (meta) meta.setAttribute('content', document.documentElement.dataset.dayHue || bg);
  }

  function getSavedTheme() {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch {
      return null;
    }
  }

  function saveTheme(theme) {
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch {
      // Ignore storage errors (e.g. private browsing).
    }
  }

  // Query toggles live so toggles added later (e.g. via SPA navigation) are
  // kept in sync too.
  function updateToggle(theme) {
    const isDark = theme === 'dark';
    document.querySelectorAll('.theme-toggle').forEach((toggle) => {
      toggle.setAttribute('aria-pressed', String(isDark));
      toggle.setAttribute(
        'aria-label',
        isDark ? toggle.dataset.lightLabel : toggle.dataset.darkLabel
      );
    });
  }

  function init() {
    const saved = getSavedTheme();
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    // No saved preference → follow the browser/system setting (auto).
    const theme = saved || (prefersDark ? 'dark' : 'light');
    applyTheme(theme);
    updateToggle(theme);
  }

  init();

  // Delegated so every theme toggle works, including ones swapped in by the SPA
  // router after initial load.
  document.addEventListener('click', function (event) {
    const toggle = event.target.closest('.theme-toggle');
    if (!toggle) return;
    const current = document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
    const next = current === 'dark' ? 'light' : 'dark';
    applyTheme(next);
    saveTheme(next);
    updateToggle(next);
    // Blur after click so focus styles (e.g., background highlight) don't linger
    toggle.blur();
  });

  // Re-sync toggles swapped in by the SPA router (e.g. returning to a page that
  // has a theme toggle) so their aria state matches the current theme.
  document.addEventListener('page:load', function () {
    const theme = document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
    updateToggle(theme);
  });
}());
